import React from "react";
import "./assets/css/style.css";
import "./assets/css/bootstrap.min.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useLocation } from "react-router-dom";

const Invoice = () => {
    const location = useLocation();
    const data = location.state[0];
    const total = location.state[2];
    console.log(data);
    

    const convertToPDF = () => {
        const targetElement = document.getElementById('pdf');
        if (targetElement) {
          html2canvas(targetElement, {
            logging: true,
            useCORS: true
          }).then((canvas) => {
            const imgWidth = 208;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const imgData = canvas.toDataURL('img/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save('aaa');
          });
        }
    }


    return(
        <div className="invoice-1 invoice-content">
            <div id="pdf" className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="invoice-inner clearfix">
                            <div className="invoice-info clearfix" id="invoice_wrapper">
                                <div className="invoice-headar">
                                    <div className="row g-0">
                                        <div className="col-sm-6">
                                            <div className="invoice-logo">
                                                <div className="logo-container">
                                                    <img href="/assets/img/logos/logo.png" alt="Company Logo" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-6 invoice-id">
                                            <div className="info">
                                                <h1 className="color-white inv-header-1">Tax Invoice</h1>
                                                <p className="color-white mb-1">Invoice Number <span> 45613</span></p>
                                                <p className="color-white mb-0">Invoice Date <span>21 Sep 2021</span></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-top">
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div className="invoice-number mb-30">
                                                <h4 className="inv-title-1">Billed To</h4>
                                                <h2 className="name mb-10">{data.firmName}</h2>
                                                <p className="invo-addr-1">
                                                    {data.Location}<br/>
                                                    {data.phone}<br/>
                                                    {data.gstNo}<br/>
                                                    {data.dlNo}<br/>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="invoice-number mb-30">
                                                <br/>
                                                <h2 className="name mb-10">{data.CustomerName} </h2>
                                                <p className="invo-addr-1">
                                                    EWAY :EWAY BILL NUMBER<br/>
                                                    E-INVOICE :E-INVOICE NUMBER<br/>
                                                    L.R. :L.R. NUMBER<br/>
                                                    TRANSPORT :TRANSPORT<br/>
                                                    DUE DATE :DUE DATE<br/>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-sm-4">
                                            <div className="invoice-number mb-30">
                                                <div className="invoice-number-inner">
                                                    <h4 className="inv-title-1">Bill From</h4>
                                                    <h2 className="name mb-10">ANANTASIA PHARMA PRIVATE LIMITED</h2>
                                                    <p className="invo-addr-1" >
                                                    Shop No - 103, First Floor <br/>
                                                    Gautam Budh Marg <br/>
                                                    A.C. Medicine Market, Aminabad <br/>
                                                    Lucknow, PIN - 226018 <br/>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table_component" role="region" tabIndex="0">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>HSN CODE</th>
                                                <th>Product Name</th>
                                                <th>QTY.</th>
                                                <th>FREE</th>
                                                <th>DIS %</th>
                                                <th>PKG*</th>
                                                <th>BATCH</th>
                                                <th>MRP</th>
                                                <th>EXPIRY</th>
                                                <th>RATE</th>
                                                <th>TAXABLE VALUE</th>
                                            </tr>
                                        </thead>
                                        <tbody id="table-body">
                                            {data.products.map((item) => (
                                                <tr>
                                                    <td>IDK</td>
                                                    <td>{item.title}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>IDK</td>
                                                    <td>IDK</td>
                                                    <td>IDK</td>
                                                    <td>IDK</td>
                                                    <td>{item.actual_price}</td>
                                                    <td>IDK</td>
                                                    <td>IDK</td>
                                                    <td>IDK</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    </div>
                                    <br/>
                                    <hr style={{height:"4px", border:"none", backgroundColor:"#010003"}}/>

                                    <div className="mb-40 payment-method">
                                        <ul className="payment-method-list-1 text-14">
                                            <li><strong>Sub Total :</strong>{total}</li>
                                            <li><strong>Discount :</strong>total_discount</li>
                                            <li><strong>SGST :</strong>total_sgst</li>
                                            <li><strong>CGST :</strong>total_cgst</li>
                                            <li><strong>IGST :</strong>total_igst</li>
                                        </ul>
                                    </div>
                                    <hr style={{height: "4px", border: "none", backgroundColor: "#000000"}} />
                                    <div style={{display: "flex", justifyContent: "space-between"}} >
                                        <div style={{fontSize: "24px", fontWeight: "bold", color: "#000000"}} >Rs. : <span style={{fontSize: "12px", color: "#000000"}}>value in words</span></div>
                                        <div style={{fontSize: "24px", fontWeight: "bold", color: "#000000", textAlign: "right"}} >GRAND TOTAL :<span style={{fontSize: "24px", color: "#000000"}} >total_bill_Value</span></div>
                                    </div>
                                    <hr style={{ height: "4px", border: "none", backgroundColor: "#000000"}} />

                                <div className="invoice-bottom">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-8 col-sm-7">
                                            <div className="mb-30 dear-client">
                                                <h3 className="inv-title-1">Terms & Conditions</h3>
                                                <p>
                                                    *Goods once sold will not be taken back or exchanged. <br/>
                                                    *Bills not paid by the due date will attract interest at 24% per annum. <br/>
                                                    *All disputes subject to the jurisdiction only. <br/>
                                                    *Prescribed Sales Tax declaration will be given. <br/>
                                                    Certified that the particulars given above are true and correct and the amount indicated represents the price actually charged.</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-4 col-sm-5">
                                            <div className="mb-30 payment-method">
                                                <h3 className="inv-title-1">Bank Details : </h3>
                                                <ul className="payment-method-list-1 text-14">
                                                    <li><strong>Account No:</strong>103305003585</li>
                                                    <li><strong>IFSC Code:</strong>ICIC0001033</li>
                                                    <li><strong>BANK Name:</strong>ICICI Bank</li>
                                                    <li><strong>Branch Name:</strong>Aminabad, Lucknow</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="invoice-contact clearfix">
                                    <div className="row g-0">
                                        <div className="col-lg-9 col-md-11 col-sm-12">
                                            <div className="contact-info">
                                                <a href="tel:+919454452089"><i className="fa fa-phone"></i>+91 9454452089</a>
                                                <a href="mailto:orders.udyog@gmail.com"><i className="fa fa-envelope"></i> orders.udyog@gmail.com</a>
                                                <a href="" className="mr-0 d-none-580"><i className="fa fa-map-marker"></i>Aminabad, Lucknow</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="invoice-btn-section clearfix d-print-none">
                <button className="btn btn-lg btn-download btn-theme" onClick={convertToPDF}>
                    <i className="fa fa-download"></i> Download Invoice
                </button>
            </div>
        </div>
    );

}

export default Invoice;